
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/servicos",
      function () {
        return require("private-next-pages/servicos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/servicos"])
      });
    }
  